// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_invoice/make_payment.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PaymentAllocation, SupplierPaymentMethod } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.MakePaymentRequest
 */
export class MakePaymentRequest extends Message<MakePaymentRequest> {
  /**
   * ID of the supplier to whom the payment is made
   *
   * @generated from field: string supplier_id = 1;
   */
  supplierId = "";

  /**
   * Method of payment (e.g., cash, bank transfer)
   *
   * @generated from field: com.neulink.pharmacy.SupplierPaymentMethod payment_method = 2;
   */
  paymentMethod = SupplierPaymentMethod.UNSPECIFIED;

  /**
   * Reference for the payment (e.g., transaction ID
   *
   * @generated from field: string payment_reference = 3;
   */
  paymentReference = "";

  /**
   * Amount to be paid
   *
   * @generated from field: float amount = 4;
   */
  amount = 0;

  /**
   * Additional notes for the payment
   *
   * @generated from field: string notes = 5;
   */
  notes = "";

  /**
   * List of allocations for the payment
   *
   * @generated from field: repeated com.neulink.pharmacy.PaymentAllocation allocations = 6;
   */
  allocations: PaymentAllocation[] = [];

  constructor(data?: PartialMessage<MakePaymentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MakePaymentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_method", kind: "enum", T: proto3.getEnumType(SupplierPaymentMethod) },
    { no: 3, name: "payment_reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "allocations", kind: "message", T: PaymentAllocation, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MakePaymentRequest {
    return new MakePaymentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MakePaymentRequest {
    return new MakePaymentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MakePaymentRequest {
    return new MakePaymentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MakePaymentRequest | PlainMessage<MakePaymentRequest> | undefined, b: MakePaymentRequest | PlainMessage<MakePaymentRequest> | undefined): boolean {
    return proto3.util.equals(MakePaymentRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.MakePaymentResponse
 */
export class MakePaymentResponse extends Message<MakePaymentResponse> {
  constructor(data?: PartialMessage<MakePaymentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MakePaymentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MakePaymentResponse {
    return new MakePaymentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MakePaymentResponse {
    return new MakePaymentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MakePaymentResponse {
    return new MakePaymentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MakePaymentResponse | PlainMessage<MakePaymentResponse> | undefined, b: MakePaymentResponse | PlainMessage<MakePaymentResponse> | undefined): boolean {
    return proto3.util.equals(MakePaymentResponse, a, b);
  }
}

